module.exports = __webpack_public_path__ + "img/news_content_1.89201a84.png";